import { render } from "./SucaiPage.vue?vue&type=template&id=e10c8828"
import script from "./SucaiPage.vue?vue&type=script&lang=js"
export * from "./SucaiPage.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__